'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier(outer, name, segment, monthly, annual, per, blurb, ctaLabel, ctaPage, ctaStyle, popular, features) {
  this.gO = null;
  this.gR = null;
  this.gN = null;
  this.gH = null;
  this.gP = null;
  this.gI = null;
  this.gJ = null;
  this.gK = null;
  this.gL = null;
  this.gQ = false;
  this.gM = null;
  this.mE = null;
  this.gO = name;
  this.gR = segment;
  this.gN = monthly;
  this.gH = annual;
  this.gP = per;
  this.gI = blurb;
  this.gJ = ctaLabel;
  this.gK = ctaPage;
  this.gL = ctaStyle;
  this.gQ = popular;
  this.gM = features;
  if ((outer === null)) {
    throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException();
  }
  this.mE = outer;
}
export { $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier as $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier };
$p = $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier() {
}
export { $h_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier as $h_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier };
$h_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, 2606594);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gO));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gR));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gN));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gH));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gP));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gI));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gJ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gK));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gL));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.gQ ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gM));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().Q(acc, 11);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier) && (x$0.mE === this.mE))) {
    if (((((((((this.gQ === x$0.gQ) && (this.gO === x$0.gO)) && (this.gR === x$0.gR)) && (this.gN === x$0.gN)) && (this.gH === x$0.gH)) && (this.gP === x$0.gP)) && (this.gI === x$0.gI)) && (this.gJ === x$0.gJ))) {
      var x = this.gK;
      var x$2 = x$0.gK;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.gL;
      var x$4 = x$0.gL;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.gM;
      var x$6 = x$0.gM;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 11;
});
$p.I = (function() {
  return "Tier";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.gO;
      break;
    }
    case 1: {
      return this.gR;
      break;
    }
    case 2: {
      return this.gN;
      break;
    }
    case 3: {
      return this.gH;
      break;
    }
    case 4: {
      return this.gP;
      break;
    }
    case 5: {
      return this.gI;
      break;
    }
    case 6: {
      return this.gJ;
      break;
    }
    case 7: {
      return this.gK;
      break;
    }
    case 8: {
      return this.gL;
      break;
    }
    case 9: {
      return this.gQ;
      break;
    }
    case 10: {
      return this.gM;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bS)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier as $isArrayOf_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier };
var $d_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier, "io.intela.sites.digitalinternship.pages.PricingPage$Tier", ({
  bS: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier as $d_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier };
//# sourceMappingURL=io.intela.sites.digitalinternship.pages.-Pricing-Page$-Tier.js.map
